import * as React from 'react';
import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import Stack from '@mui/material/Stack';
import IntlMessages from '../../util/IntlMessages'
import useStyles from './styles'

export default function SecondsTimePicker(props) {
    const classes = useStyles()

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Stack spacing={3}>
                <TimePicker
                    ampm={false}
                    className={classes.root}
                    openTo="hours"
                    views={['hours', 'minutes']}
                    inputFormat="HH:mm"
                    mask="__:__"
                    cancelText={<IntlMessages id="cancel"/>}
                    okText={<IntlMessages id="confirmation"/>}
                    label={props.label}
                    value={props.value}
                    onChange={props.onChange}
                    renderInput={(params) => <TextField {...params} />}
                />
            </Stack>
        </LocalizationProvider>
    );
}
